<span>
  <a [attr.href]="!!emailAddress ? 'mailto:' + emailAddress : null">
    <div class="px-1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      @if (displayName || emailAddress) {
        <topo-avatar [name]="displayName || emailAddress" [organizationUId]="organizationUId" [userProfileUId]="userProfileUId"></topo-avatar>
      }
      <div>
        <div fxLayout="row">
          {{ displayName }}
        </div>
      </div>
    </div>
  </a>
</span>
